export const AUTH0_DOMAIN = "support-pp.eu.auth0.com";
export const AUTH0_AUDIENCE = "https://api-whatsapp.support-pp.de";
export const AUTH0_CLIENT_ID = "gdFpgKwPDsabW73IVJxnAWArJCL1bePV";
export const phoneNumber = "+4982256239700";

export const phoneNumberFormated = "+49 8225 62 39 700";
